export default "__VITE_ASSET__fa9e72ed__"